import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service'; // Assurez-vous que AuthService est bien importé

@Injectable({
  providedIn: 'root'
})


export class GuestGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    
    if (this.authService.isAuthenticated()) {
      
      // Rediriger vers PostFeedComponent si l'utilisateur est connecté
      this.router.navigate(['/postfeed']);
      return false;
      
    } else {
      if (this.authService.isAuthenticated()) {
      
        // Rediriger vers PostFeedComponent si l'utilisateur est connecté
        this.router.navigate(['/postfeed']);
        return false;
        
      }
      this.router.navigate(['/home']);
      return true;  // Permettre l'accès à HomeComponent si l'utilisateur n'est pas connecté
    }
  }
}

export class GuestGuard2 implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    
    if (this.authService.isAuthenticated()) {
      
      // Rediriger vers PostFeedComponent si l'utilisateur est connecté
      this.router.navigate(['/postfeed']);
      return false;
      
    } else {
      if (this.authService.isAuthenticated()) {
      
        // Rediriger vers PostFeedComponent si l'utilisateur est connecté
        this.router.navigate(['/postfeed']);
        return false;
        
      }
      this.router.navigate(['/home2']);
      return true;  // Permettre l'accès à HomeComponent si l'utilisateur n'est pas connecté
    }
  }
}
